export enum Routes {
  Root = '/',
  Login = '/login',
  VerifyUser = '/verify-user',
  Recent = '/recent',
  Favorites = '/favorite-items',
  All = '/all',
}

export enum AuthRoutes {
  OAuth = '/oauth',
  OAuthCallback = '/oauth-callback',
  SAML = '/saml',
  SAMLProviders = '/saml/providers',
}

export const ShopifyAppRoutes = {
  all: (workspaceId: string) => `/${workspaceId}${Routes.All}`,
  allClip: (clipId: string, workspaceId: string) => `/${workspaceId}${Routes.All}/c/${clipId}`,
  board: (boardId: string, workspaceId: string) => `/${workspaceId}/b/${boardId}`,
  boardClip: (boardId: string, clipId: string, workspaceId: string) => `/${workspaceId}/b/${boardId}/c/${clipId}`,
  favorites: (workspaceId: string) => `/${workspaceId}${Routes.Favorites}`,
  favoritesClip: (clipId: string, workspaceId: string) => `/${workspaceId}${Routes.Favorites}/c/${clipId}`,
  library: (libraryId: string, workspaceId: string) => `/${workspaceId}/l/${libraryId}`,
  recent: (workspaceId: string) => `/${workspaceId}${Routes.Recent}`,
  recentClip: (clipId: string, workspaceId: string) => `/${workspaceId}${Routes.Recent}/c/${clipId}`,
  root: (workspaceId: string) => `/${workspaceId}`,
};

const SHOPIFY_ADMIN_BASE = 'https://admin.shopify.com/store';

export const ShopifyAdminRoutes = {
  newProduct: (storeName: string) => `${SHOPIFY_ADMIN_BASE}/${storeName}/products/new`,
  product: (storeName: string, productId: string) => `${SHOPIFY_ADMIN_BASE}/${storeName}/products/${productId}`,
  products: (storeName: string) => `${SHOPIFY_ADMIN_BASE}/${storeName}/products`,
};
